import api from "./api";

export const fetchCenters = async () => {
  const res = await api.get("/api/v1/dashboard/centers");
  return res.data;
};

export const fetchWisdomCenters = async () => {
  const res = await api.get("/api/v1/dashboard/wisdom/centers");
  return res.data;
};

export const fetchWisdomCenterEvaluationBreakdown = async (centerId) => {
  const res = await api.get(`/api/v1/dashboard/wisdom/center/${centerId}/evaluation-breakdown`);
  return res.data;
};

export const fetchWisdomAnnualPerformanceData = async (organizationId) => {
  try {
    const res = await api.get(`/api/v1/dashboard/wisdom/center/${organizationId}/annual-performance`);
    return res.data;
  } catch (error) {
    console.error('Error fetching Wisdom annual performance data:', error);
    throw error;
  }
};

export const fetchWisdomProjectUnitsRanking = async (organizationId) => {
  try {
    const res = await api.get(`/api/v1/dashboard/wisdom/center/${organizationId}/project-units-ranking`);
    return res.data;
  } catch (error) {
    console.error('Error fetching Wisdom project units ranking data:', error);
    throw error;
  }
};

export const fetchWatomsDetailsData = async (userOrganization, year) => {
  try {
    const response = await api.get(`/api/v1/dashboard/watoms/forms/score/${userOrganization}/${year}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomDetailsData = async (year, filters) => {
  try {
    const safeStage = filters.stage && filters.stage !== "" ? filters.stage : "All";
    const safeSubject = filters.subject && filters.subject !== "" ? filters.subject : "All";
    const safeSpecialization =
      filters.specialization && filters.specialization !== "" ? filters.specialization : "All";
    const safeFromDate =
      filters.from && filters.from !== "" ? filters.from : "All";
    const safeToDate =
      filters.to && filters.to !== "" ? filters.to : "All";

    const response = await api.get(
      `/api/v1/wisdom/dashboard/${year}/${safeStage}/${safeSubject}/${safeSpecialization}/${safeFromDate}/${safeToDate}`
    );
    return response.data.dashboard;
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchDemoDetailsData = async () => {
  try {
    const response = await api.get(`/api/v1/dashboard/demo/forms/score`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
};

export const submitManagerEvaluation = async (data) => {
  try {
    const response = await api.post(`/api/v1/watoms/managers/evaluation`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.Points || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
}

export const updateEmployeeEvaluation = async (data) => {
  try {
    const response = await api.patch(`/api/v1/watoms/employee/evaluation`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.Points || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
}

export const submitOrgTaskAvg = async (data) => {
  try {
    const response = await api.post(`/api/v1/watoms/organization/task-score`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.taskScore || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
}

export const submitMangerComment = async (data) => {
  try {
    const response = await api.post(`/api/v1/watoms/manager/comment`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.taskScore || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
}

export const fetchCROData = async (year) => {
  try {
    if (!year) year = 2025 
    const response = await api.get(`/api/v1/dashboard/watoms/cro/evaluation/${year}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
};

export const wisdomFetchCROData = async () => {
  try {
    const response = await api.get(`/api/v1/dashboard/wisdom/cro/evaluation`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
};

// Graduates API functions
export const fetchGraduates = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.organizationId) params.append('organizationId', filters.organizationId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.specializationId) params.append('specializationId', filters.specializationId);
    if (filters.search) params.append('search', filters.search);

    const response = await api.get(`/api/v1/dashboard/graduates?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching graduates:', error);
    throw error;
  }
};

export const fetchGraduateStats = async (organizationId = null) => {
  try {
    const params = organizationId ? `?organizationId=${organizationId}` : '';
    const response = await api.get(`/api/v1/dashboard/graduates/stats${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching graduate stats:', error);
    throw error;
  }
};

// Applicants API functions
export const fetchApplicants = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.organizationId) params.append('organizationId', filters.organizationId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.search) params.append('search', filters.search);

    const response = await api.get(`/api/v1/dashboard/applicants?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching applicants:', error);
    throw error;
  }
};

export const fetchApplicantStats = async (organizationId = null) => {
  try {
    const params = organizationId ? `?organizationId=${organizationId}` : '';
    const response = await api.get(`/api/v1/dashboard/applicants/stats${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching applicant stats:', error);
    throw error;
  }
};